import { AssessmentInfo } from 'generated/graphql';

export interface AssessmentInfoViewModel {
  entityTypeId?: string
  level: number;
  description: string;
  detailedDescription?: string;
  color: string;
  class: string;
}

export function mapAssessmentInfoToVM(
  assessmentInfo: AssessmentInfo,
  entityTypes: Array<{ id: string }> = [],
  zeroAssessment: AssessmentInfoViewModel): AssessmentInfoViewModel[] {

  // Always add the zero assessment to the levels
  const result: AssessmentInfoViewModel[] = [];

  const defaultValues = [zeroAssessment, ...assessmentInfo
    .descriptions
    .map<AssessmentInfoViewModel>((desc, index) => ({
      entityTypeId: null,
      description: desc,
      color: assessmentInfo.colors[index],
      detailedDescription: assessmentInfo.detailedDescriptions[index],
      class: `a${assessmentInfo.colors[index]}`,
      level: index + 1
    }))];

  // Add default values to the result array
  defaultValues.forEach((value) => {
    result.push(value);
  })

  // We want to create an array for each of the entity types, but apply the overriden values from
  // assessmentInfo.entityTypeOverrides if exists
  entityTypes.forEach((entityType) => {
    // we have a zero assessment here!
    defaultValues.forEach((defaultValue) => {
      const copy = { ...defaultValue };
      copy.entityTypeId = entityType.id;
      const override = assessmentInfo.entityTypeOverrides.find(o => o.entityTypeId === entityType.id);
      if (override) {
        // Minus 1 because we don't store 0 assessment in the DB,
        copy.description = override.descriptions[defaultValue.level - 1];
        copy.detailedDescription = override.detailedDescriptions[defaultValue.level - 1];
      }
      result.push(copy);
    });
  });

  // Backfill the zero assessment for all levels, sometimes this is not occurring
  // but this is a quick fix.
  result.filter(a => a.level === 0)
    .forEach((assessment) => {
      assessment.description = zeroAssessment.description;
      assessment.detailedDescription = zeroAssessment.detailedDescription;
      assessment.color = zeroAssessment.color;
    });


  return result;
}
